function fixSeparators(path: string): string {
	return path.replace("\\", "/");
}

function getFileName(path: string): string {
	path = fixSeparators(path);
	const i = path.lastIndexOf("/") + 1;
	return path.slice(i);
}

function getExtension(path: string): string {
	path = fixSeparators(path);
	const separator = ".";
	const fileName = getFileName(path);
	const separatorIndex = fileName.lastIndexOf(separator);
	return separatorIndex === -1 ? "" : fileName.substr(separatorIndex);
}

function getFileNameWithoutExtension(path: string): string {
	path = fixSeparators(path);
	const separator = ".";
	const fileName = getFileName(path);
	const separatorIndex = fileName.lastIndexOf(separator);
	return separatorIndex === -1 ? fileName : fileName.substr(0, separatorIndex);
}

export {
	getFileName,
	getExtension,
	getFileNameWithoutExtension,
};
